import { Button, ButtonVariant, Text } from "@merge-api/merge-javascript-shared";

interface Props {
  illustration: string;
  illustrationAlt: string;
  code?: string;
  title: string;
  message: string;
  actionLabel: string;
  actionVariant?: ButtonVariant;
  onAction: () => void;
}

/**
 * Full-page error state with a Merge Manta illustration. The SVGs load through <img> so each
 * file's IDs and styles stay isolated, and their animations already honor reduced motion.
 */
const ErrorPage = ({
  illustration,
  illustrationAlt,
  code,
  title,
  message,
  actionLabel,
  actionVariant,
  onAction,
}: Props) => (
  <div className="flex flex-col items-center px-6 py-16 text-center">
    <img
      src={illustration}
      alt={illustrationAlt}
      width={400}
      height={320}
      className="h-auto max-w-full"
    />
    {code && (
      <Text variant="h4" className="mt-2 tracking-widest text-gray-20">
        {code}
      </Text>
    )}
    <Text variant="h3" className="mt-3">
      {title}
    </Text>
    <Text className="mt-2 text-gray-40">{message}</Text>
    <Button className="mt-5" variant={actionVariant} onClick={onAction}>
      {actionLabel}
    </Button>
  </div>
);

export default ErrorPage;
